module.exports = __webpack_public_path__ + "99eda7f36986877749b7f9c422493030.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/prologis_2023_chart.png
// module id = 1725
// module chunks = 0